import { render } from "./TicketLisDetail.vue?vue&type=template&id=48df6d36"
import script from "./TicketLisDetail.vue?vue&type=script&lang=js"
export * from "./TicketLisDetail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bert\\Documents\\Projects\\lis-ticket-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__